import {State} from '../../Store';
import {Store} from 'vuex';
import {EditorUploadsMutation, EditorUploadsState} from '../../modules/editor/Uploads';

export class EditorUploadsStoreControllerClass {
	private _store!: Store<State>;

	private static _instance: EditorUploadsStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorUploadsStoreControllerClass());
	}

	private constructor() {}

	set_store(store: Store<State>) {
		this._store = store;
	}

	// getters
	get local_state(): EditorUploadsState {
		return (<unknown>(this._store.state.editor as any).uploads) as EditorUploadsState;
	}
	reload_required(): boolean {
		return this.local_state.reload_required;
	}

	// mutations
	set_reload_required() {
		this._store.commit(`editor/uploads/${EditorUploadsMutation.SET_RELOAD_REQUIRED}`);
	}
	unset_reload_required() {
		this._store.commit(`editor/uploads/${EditorUploadsMutation.UNSET_RELOAD_REQUIRED}`);
	}
}

export const EditorUploadsStoreController = EditorUploadsStoreControllerClass.instance();
